import { createFileRoute } from "@tanstack/react-router";

import Security from "@/features/security/Security";

export const Route = createFileRoute("/_auth/security/")({
  component: Security,
});
